import React from "react";
import ContentWrapper from "@/res/components/ClientCreate/content-wrapper";
import { useTranslation } from "react-i18next";

const ContentSales = (props) => {
    const [t] = useTranslation();

    return (
        <ContentWrapper {...props}>
            <h2>
                {t("pages.start.header-sales")} <span style={{ color: "#244a66" }}>
                    {props?.details?.label}
                </span>
            </h2>
        </ContentWrapper>
    );
};

export default ContentSales;
